<template>
  <div>
    <section class="content-start pb-12" role="main">
      <top-navigation></top-navigation>
      <div v-if="siteCode">
        <v-warning-message
          v-if="showWarningMessage()"
          :warning="warningDetails.warning"
          :html="true"
          :show-close="true"
          @close="closeWarning()"
        />
        <v-header>
          <router-view :key="$route.fullPath" name="patientheader" />
        </v-header>
        <router-view />
        <!-- Chat functionality component -->
        <v-prescriber-chat />
      </div>
    </section>
    <v-prescriber-signature v-if="isLoggedIn && !signatureSaved" />
    <v-departments v-else-if="isLoggedIn && forceSecurityPolicySelection" @close="closeModal" />
  </div>
</template>

<script>
import VHeader from '@/components/sections/Header';
import VDepartments from '@/components/sections/login/Departments';
import VWarningMessage from '@/components/shared/WarningMessage';
import router from '@/router';
import VPrescriberChat from '@/components/sections/PrescriberChat';
import VPrescriberSignature from '@/components/sections/PrescriberSignature';
import { isLoggedIn$, storeForceSecurityPolicySelection, currentUserIdentity$ } from '@/services';
import TopNavigation from '@/components/sections/navigation/TopNavigation';
import { computed, onBeforeMount } from 'vue';
import { useStore, mapActions } from 'vuex';

export default {
  name: 'VMain',
  components: {
    VHeader,
    VDepartments,
    VWarningMessage,
    VPrescriberChat,
    VPrescriberSignature,
    TopNavigation
  },
  beforeRouteUpdate(to, from, next) {
    this.routerCurrentPath = to.path;
    next();
  },
  setup() {
    const store = useStore();
    const warningDetails = computed(() => store.getters['search/getWarningDetails']);
    const signatureSaved = computed(() => store.getters['prescriber/getSignatureSaved']);
    const siteCode = computed(() => store.getters['navigation/getSiteCode']);
    onBeforeMount(() => {
      store.dispatch('search/fetchWarning');
    });
    return {
      warningDetails,
      signatureSaved,
      siteCode,
      store
    };
  },
  data() {
    // Subscribe to the observable on component creation
    let user = null;
    currentUserIdentity$.subscribe({
      next: (data) => {
        user = data;
      }
    });
    let isLoggedIn = null;
    isLoggedIn$.subscribe({
      next: (data) => {
        isLoggedIn = data;
      }
    });
    return {
      hideDesktopHamburgerMenu: true,
      showWarning: false,
      trackClose: false,
      animated: false,
      sidebarCollapsed: false,
      forceSecurityPolicySelection: true,
      user,
      isLoggedIn,
      ...mapActions('search', ['fetchWarning'])
    };
  },
  watch: {
    warningDetails(value, newValue) {
      if (value && newValue && value.warning !== newValue.warning) {
        if (value.warning && !this.trackClose) {
          this.showWarning = true;
        }
      }
    }
  },
  mounted() {
    this.sidebarCollapsed = JSON.parse(window.localStorage.getItem('sidebar-collapsed'));
    this.forceSecurityPolicySelection = JSON.parse(window.localStorage.getItem('forceSecurityPolicySelection'));
    if (this.user && this.user.featureFlags) {
      let fetureFlags = this.user.featureFlags;
      if (fetureFlags && fetureFlags.prescriberDashboardWarning) {
        this.store.dispatch('search/fetchWarning', 'PrescriberDashboardWarning');
      }
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    closeWarning() {
      this.showWarning = false;
    },
    showWarningMessage() {
      return router.currentRoute.value.name === 'main' && this.warningDetails.warning && this.showWarning;
    },
    closeModal() {
      storeForceSecurityPolicySelection(false);
      this.forceSecurityPolicySelection = false;
    }
  }
};
</script>
